import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HeaderService } from '../header.service';
import RoutesserviceService from '../routesservice.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PayrollService {
  private showValuesSubject = new BehaviorSubject<boolean>(this.getInitialShowValues());
  showValues$ = this.showValuesSubject.asObservable();

  constructor(
    private httpClient: HttpClient,
    private Customeroutes: RoutesserviceService,
    private HeaderService: HeaderService
  ) { }

  private getInitialShowValues(): boolean {
    const stored = localStorage.getItem('showPayrollValues');
    return stored ? JSON.parse(stored) : true;
  }

  toggleShowValues() {
    const newValue = !this.showValuesSubject.value;
    localStorage.setItem('showPayrollValues', JSON.stringify(newValue));
    this.showValuesSubject.next(newValue);
  }

  get showValues(): boolean {
    return this.showValuesSubject.value;
  }

  async getPayroll(month: any, year: any) {
    const formdata = {
      month: month,
      year: year,
    }
    return this.httpClient
      .post(this.Customeroutes.getAllPayroll(), formdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
        }
      });
  }
  async getPayrollFilter(sdate: any, edate: any, month: any, year: any) {
    const formdata = {
      start_date: sdate,
      end_date: edate,
      month: month,
      year: year,
    };
    return this.httpClient
      .post(this.Customeroutes.getPayrollFilters(), formdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
        }
      });
  }

  async getPaySlip(month: any, year: any) {
    const formdata = {
      month_pay_salary: month,
      year_pay_salary: year,
    };
    return this.httpClient
      .post(this.Customeroutes.getPaySlipData(), formdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
        }
      });
  }



  // loan requests
  async getLoanReq() {
    return this.httpClient
      .get(this.Customeroutes.getUserLoans(), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data) {
          if (data.success == true) {

            //if login is true the store it into local storage
            // localStorage.setItem('token', data.data.token);
            return data;
            // this.showSpinner=false;
          }
        }
        return data;
      });
  }


  async delLoanreq(id: any) {
    const formdata = {
      id: id,
    };

    return this.httpClient
      .post(this.Customeroutes.getDelateLoan(), formdata, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }


  async getuserReq(id: any) {

    return this.httpClient
      .get(this.Customeroutes.getLoan(id), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data) {
          if (data.success == true) {
            return data;
          }
        }
        return data;
      });

  }


  async LoanReq(id: any) {

    return this.httpClient
      .get(this.Customeroutes.getLoanDetail(id), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });

  }



  async uploadLoan(id: any,
    loanAmountValue: any,
    loanDate: any,
    selectedDuration: any,
    InstallmentAmount: any,
    loanPurpose: any,
    profile_image: any,
    loan_file: any

  ) {

    const loanRequest = {
      id: id,
      loan_amount: loanAmountValue,
      loan_date: loanDate,
      loan_duration: selectedDuration,
      installment: InstallmentAmount,
      loan_reason: loanPurpose,
      profile_image: profile_image,
      loan_file: loan_file
    };

    return this.httpClient
      .post(this.Customeroutes.getUpdateLoan(), loanRequest, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }




  async getPayrollSummary(type: any, year?: any) {
    const url = this.Customeroutes.getpaySummary(type, year);

    return this.httpClient
      .get(url, {
        headers: this.HeaderService.getHeaderWithToken(localStorage.getItem('token')),
      })
      .toPromise()
      .then((data: any) => {
        return data && data.success ? data : data;
      });
  }





  async getSummarypayRoll(month: any, year: any) {

    const summaryRequest = {
      month: month,
      year: year
    };

    return this.httpClient
      .post(this.Customeroutes.getpayrollSummary(), summaryRequest, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }


  async getKeys() {
    return this.httpClient
      .post(this.Customeroutes.leaveModifiDate(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }

  async getYearlyPayroll(year: any) {

    const summaryRequest = {
      year: year
    };

    return this.httpClient
      .post(this.Customeroutes.getyearlyPayroll(), summaryRequest, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }


  async getDepartmentSummary(month: any, year: any) {

    const summaryRequest = {
      month: month,
      year: year
    };

    return this.httpClient
      .post(this.Customeroutes.getdepartmetPayroll(), summaryRequest, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }




  async getMonthlyList() {
    return this.httpClient
      .post(this.Customeroutes.getMonthlyPayroll(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }




  async getuserDetailList(filters: any = {}, page = 1, limit = 20) {
    return this.httpClient
      .post(
        `${this.Customeroutes.getuserDetailList()}?page=${page}&limit=${limit}`, // <-- send limit in query
        filters,
        {
          headers: this.HeaderService.getHeaderWithToken(
            localStorage.getItem('token')
          ),
        }
      )
      .toPromise()
      .then((data: any) => {
        if (data?.success === true) {
          return data;
        }
        return null;
      });
  }


  async getAllAdmins() {
    return this.httpClient
      .post(this.Customeroutes.getAllAdmins(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }





  async sendMailAdmin(payload: any) {
    return this.httpClient
      .post(this.Customeroutes.sendMailAdmin(), payload, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }



  async getuserHistory(payload: any) {
    return this.httpClient
      .post(this.Customeroutes.getuserHistory(), payload, {
        headers: this.HeaderService.getHeaderWithToken(localStorage.getItem('token')),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success) {
          return data;
        }
        return null;
      });
  }



  async getReviewCheck() {

    return this.httpClient
      .post(this.Customeroutes.getReviewCheck(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }



  async sendReviewChange(id: any, reason: any) {

    const summaryRequest = {
      monthly_salary_id: id,
      reason: reason
    };

    return this.httpClient
      .post(this.Customeroutes.sendReviewChanges(), summaryRequest, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }


  async approvePayroll(id: any) {

    const summaryRequest = {
      monthly_salary_id: id
    };

    return this.httpClient
      .post(this.Customeroutes.approvePayroll(), summaryRequest, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }



  async addParollEntery(month_int: any, month_char: any, month_year: any) {

    const summaryRequest = {
      month_int: month_int,
      month_char: month_char,
      month_year: month_year
    };

    return this.httpClient
      .post(this.Customeroutes.addPayrollEntry(), summaryRequest, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }



  async checkReview(id: any) {

    const summaryRequest = {
      monthly_total_salary_id: id
    };

    return this.httpClient
      .post(this.Customeroutes.checkReview(), summaryRequest, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }


  async getPayrollMonth(month_int: any, year: any) {

    const summaryRequest = {
      month_int: month_int,
      month_year: year
    };

    return this.httpClient
      .post(this.Customeroutes.getPayrollMonth(), summaryRequest, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }


  async getmonthSalary(year: any, month_int: any,) {

    const summaryRequest = {
      month: month_int,
      year: year
    };

    return this.httpClient
      .post(this.Customeroutes.getmonthSalary(), summaryRequest, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }



  async getdetailPayrollMonth(id: any) {

    const summaryRequest = {
      id: id,
    };

    return this.httpClient
      .post(this.Customeroutes.getdetailmonthSalary(), summaryRequest, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
      });
  }

}
